module.exports = __webpack_public_path__ + "img/1F1EA-1F1E8.692d1244.svg";